import IconAppliances from '@whitelabel/media/icons/policies/appliances.svg';
import IconElectronics from '@whitelabel/media/icons/policies/electronics.svg';
import IconFurniture from '@whitelabel/media/icons/policies/furniture.svg';
import IconSunglasses from '@whitelabel/media/icons/policies/sunglasses.svg';
import IconOutdoors from '@whitelabel/media/icons/policies/outdoor.svg';
import IconSports from '@whitelabel/media/icons/policies/sports.svg';
import IconCyber from '@whitelabel/media/icons/policies/cyber.svg';
import PGASompoImage from '@whitelabel/media/icons/pga-sompo.png';
import PGASignature from '@whitelabel/media/icons/pga-signature.png';
import UICSompoImage from '@whitelabel/media/icons/uic-sompo.jpg';
import FeCreditSignature from '@whitelabel/media/icons/fe-credit-signature.png';

export const CATEGORY = {
  APPLIANCES_INSURANCE: 'appliances-insurance',
  ELECTRONICS_INSURANCE: 'electronics-insurance',
  FURNITURE_INSURANCE: 'furniture-insurance',
  SUNGLASSES_INSURANCE: 'sunglasses-insurance',
  OUTDOORS_INSURANCE: 'outdoors-insurance',
  SPORTS_AND_FITNESS_INSURANCE: 'sports-and-fitness-insurance',
  CYBER_INSURANCE: 'cyber_insurance',
};

export const CATEGORY_ICONS = {
  [CATEGORY.APPLIANCES_INSURANCE]: IconAppliances,
  [CATEGORY.ELECTRONICS_INSURANCE]: IconElectronics,
  [CATEGORY.FURNITURE_INSURANCE]: IconFurniture,
  [CATEGORY.SUNGLASSES_INSURANCE]: IconSunglasses,
  [CATEGORY.OUTDOORS_INSURANCE]: IconOutdoors,
  [CATEGORY.SPORTS_AND_FITNESS_INSURANCE]: IconSports,
  [CATEGORY.CYBER_INSURANCE]: IconCyber,
};

export const XCOVER_PARTNER_ID = 'S6QVK';
export const AXS_PARTNER_ID = 'DQ3CJ';
export const EBAY_PARTNER_ID = 'ZNJ0A';
export const SHOPEE_PARTNER_ID = '3AZ60';
export const QUICKBOOKS_PARTNER_ID = 'LC1T0';
export const TILE_PARTNER_ID = '1H6C5';
export const FUNRAISIN_PARTNER_ID = '3014D';
export const PETPAL_PARTNER_ID = '0QRA8';
export const SKYSCANNER_PARTNER_ID = 'YE4IA';
export const AMAZON_PARTNER_ID = 'OBWZH';
export const AWS_PARTNER_ID = 'ELKU6-G3NME-INS';
export const AWS_CYBER_PROTECTION_PARTNER_ID = 'W4HO6';
export const SHIPRUSH_PARTNER_ID = 'N1428';
export const NATIONAL_EXPRESS_ID = '5V029';
export const ETRAVELI_PARTNER_ID = 'VEYWS';
export const WAYFAIR_PARTNER_ID = 'I6F3D';
export const ONBUY_PARTNER_ID = 'JU3GG';
export const ICELAND_AIR_PARTNER_ID = 'SCAX2';
export const OLA_PARTNER_ID = 'K2Z2L';
export const RMS_PARTNER_ID = 'T69U3';
export const WEGO_PARTNER_ID = 'P2FEN';
export const RYANAIR_PARTNER_ID = '71RKO';
export const AIRBALTIC_PARTNER_ID = 'O2PKF';
export const RHINO_PARTNER_ID = 'AO2WW';
export const AIRMALTA_PARTNER_ID = 'W73W3';
export const AXS_SWEDEN_PARTNER_ID = 'DA29D';

export const INTERNAL_PARTNERS = [AXS_PARTNER_ID, XCOVER_PARTNER_ID, EBAY_PARTNER_ID];
export const ALLOW_MODIFICATIONS = [SKYSCANNER_PARTNER_ID, AMAZON_PARTNER_ID];
export const MODIFY_VIA_SUPPORT = [AMAZON_PARTNER_ID];
export const DISALLOW_CANCELLATIONS = [AMAZON_PARTNER_ID];

export const AWS_SESSION_STORAGE_KEY = 'xcover-aws-questionnaire';

export const GENERALI_UNDERWRITER_NAME = 'Generali US';

export const QUOTE_QUESTIONS = 'quoteQuestions';
export const QUOTE_VALUES = 'quoteValues';
export const QUOTE_VALUES_FROM_URL = 'quoteValuesFromUrl';
export const CLAIM_JOURNEY_ID = 'claimJourneyID';
export const CLAIM_JOURNEY_DATA = 'claimJourneyData';
export const SAVED_CLAIMS = 'savedClaims';
export const LAST_CLAIM_TYPE_ID = 'lastClaimTypeID';

export const MEDIA_TYPE = {
  EMAIL: 'email',
  PHONE: 'phone',
};

export const SEARCH_TYPE = {
  REF_NUMBER: 'refNumber',
  TRACKING_NUMBER: 'trackingNumber',
};

export const SECURITY_TOKEN = 'securityToken';
export const XCOVER_TOKEN = 'xcoverToken';
export const XPAY_TOKEN = 'xpayToken';
export const CONNECTED_TO_PAYPAL = 'connectedToPaypal';
export const CLOSE_PAYPAL_MODAL = 'closePaypalModal';
export const PAYOUT_BOOKINGID = 'payoutBookingID';
export const SKIP_SUMMARY_PAGE = 'skipSummaryPage';

export const SOURCE = 'source';
export const VALUE = 'value';
export const SOURCE_SMS = 'sms';
export const SOURCE_EMAIL = 'email';

export const SIGNUP = 'signup';
export const SIGNUP_PHONE = 'phone';
export const EMAIL_PARAM = 'email';
export const BOOKING_ID = 'bookingID';
export const hiddenLocaleCodes = ['en-us'];

// Avoid to use this constant if possible,
// Use partner id constant instead for accuracy.
// eg: EBAY_PARTNER_ID
export const PARTNER_SLUG = {
  skyscanner: 'skyscanner',
};

export const CHARGE_TYPES = {
  AUTHORISATION: 'AUTHORISATION',
  ONE_OFF: 'ONE_OFF',
};

// Regex
export const REGEX_INS_ALL_CASES = /([A-Z0-9]{5}-){2}INS/i;
export const REGEX_UUID = /[a-z0-9]{8}-([a-z0-9]{4}-){3}[a-z0-9]{12}/g;

export const PUBLIC_NAV_ITEMS = [
  {
    key: 'about',
    messageKey: 'aboutLink',
    name: 'About',
    path: '/about',
  },
];

export const ACCOUNT_NAV_ITEMS = [
  {
    key: 'account',
    messageKey: 'accountLink',
    name: 'Your Policies',
    path: '/account',
    activePaths: ['/coi/', '/modify/', '/pds/', '/notify/'],
  },
  {
    key: 'help',
    messageKey: 'makeClaimLink',
    name: 'Your Claims',
    path: '/account/claims/fnol/',
    tag: 'a',
  },
];

export const MIME_TYPES = {
  jpeg: ['image/jpeg', 'image/pjpeg'],
  jpg: ['image/jpeg', 'image/pjpeg'],
  tiff: ['image/tiff'],
  gif: ['image/gif'],
  bmp: ['image/bmp', 'image/x-bmp', 'image/x-ms-bmp'],
  png: ['image/png'],
  svg: ['image/svg+xml'],
  pdf: ['application/pdf', 'application/acrobat', 'application/nappdf', 'application/x-pdf', 'image/pdf'],
  mp4: ['video/mp4', 'video/mp4v-es', 'video/x-m4v'],
  avi: ['video/avi', 'video/divx', 'video/msvideo', 'video/vnd.divx', 'video/x-avi', 'video/x-msvideo'],
  mov: ['video/quicktime'],
  wmv: ['audio/x-ms-wmv', 'video/x-ms-wmv'],
  mpg: ['video/mpeg', 'video/mpeg-system', 'video/x-mpeg', 'video/x-mpeg-system', 'video/x-mpeg2'],
  mpeg: ['video/mpeg', 'video/mpeg-system', 'video/x-mpeg', 'video/x-mpeg-system', 'video/x-mpeg2'],
  webm: ['video/webm'],
  flv: ['video/x-flv', 'application/x-flash-video', 'flv-application/octet-stream', 'video/flv'],
  csv: ['text/csv'],
  txt: ['text/plain'],
};

export const SITE_NAME = 'XCover.com';

export const FNOL_FIELDS = 'fnolFields';
export const FNOL_ERRORS = 'fnolErrors';
export const CLAIM_HELP_PAGE = 'claim-help';

export const MAP_ERROR_CODE_TO_STATIC_PAGE_SLUG: Partial<Record<string, string>> = {
  'XCLAIM.FNOL_ACCESS.CLAIM_LIMIT_REACHED': 'claim_already_submitted_fnol_error',
};

export const POSTCODE_PARAM = 'param';

export const ASIAN_COUNTRIES = ['TH', 'SG', 'MY', 'ID', 'VN', 'SK', 'HK', 'PH', 'TW'];

export const COVER_GENIUS_SGD_ENTITY = 'Cover Genius Singapore Pte Ltd';
// zendesk custom field ids
export const LANGUAGE_FILED_ID = 360000222295;
export const CUSTOMER_RATING_FIELD_ID = 360013227335;

export const TRUSTPILOT_REVIEW_URL = 'https://www.trustpilot.com/evaluate/xcover.com'; // updated based on business request

export enum IMPERSONATE {
  CUSTOMER_ID = 'customer_id',
  ADMIN_USERNAME = 'admin_username',
  CUSTOMER_EMAIL = 'customer_email',
}
export const WRONG_USERNAME_OR_PASSWORD = 'Incorrect username or password.';
export const CONFIRMATION_EMAIL = 'confirmation_email';
export const UTM_SOURCE = 'utm_source';
export const MAX_BOOKINGS_PER_REVIEW = 20;
export const ENABLE_QUOTE_AND_BOOKING = false;
export const POLICY_IS_CANCELLED = 'policyIsCancelled';
export const HELP_CENTER_HOMEPAGE_SLUG = 'help-center';
export const LOGIN_MODAL_HEADER_SLUG = 'login-modal-header';
export const HELP_LOGIN_MODAL_DISPLAYED = 'helpLoginModalDisplayed';
export const PDS_LOGIN_MODAL_DISPLAYED = 'pdsLoginModalDisplayed';

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum ERROR_CODE {
  ALREADY_REGISTERED = '20110',
  EXTERNAL_SERVICE_ERROR = '10000',
  XCORE_GENERIC_ERROR = '10100',
  XCMS_GENERIC_ERROR = '10200',
  XCLAIM_GENERIC_ERROR = '10300',
  XPAY_GENERIC_ERROR = '10400',
  GENERIC_SIGNUP_ERROR = '20100',
  TOKEN_MISMATCH = '20120',
  EMAIL_NOT_FOUND = '20140',
  PHONE_NOT_FOUND = '20150',
}
export const stateMapUSCA = {
  alabama: 'AL',
  alaska: 'AK',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  florida: 'FL',
  georgia: 'GA',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  'west virginia': 'WV',
  wisconsin: 'WI',
  wyoming: 'WY',
  alberta: 'AB',
  'british columbia': 'BC',
  manitoba: 'MB',
  'new brunswick': 'NB',
  'newfoundland and labrador': 'NL',
  'nova scotia': 'NS',
  nunavut: 'NU',
  'northwest territories': 'NT',
  ontario: 'ON',
  'prince edward island': 'PE',
  quebec: 'QC',
  saskatchewan: 'SK',
  yukon: 'YT',
};

export const SHOW_MODIFY_SUCCESS = 'showModifySuccess';
export const NPS_SELECTED_PASH_LIST = 'npsSelectedPASHList';
export const NPS_ACCOUNT_SELECTED = 'npsAccountSelected';
// XCOM-2390 predefined customers to see chat features on prod
export const TEST_CHAT_CUSTOMER_EMAILS = [
  'darin+qantasdemo@covergenius.com',
  'darin+qantasdemoaccount@covergenius.com',
  'darin+chasedemo2@covergenius.com',
];

export const UNDERWRITER_TYPE = {
  PGA_SOMPO_INSURANCE_CORPORATION: 'PGA Sompo Insurance Corporation',
  UNITED_INSURANCE_COMPANY_OF_VIETNAM: 'United Insurance Company of Vietnam',
};

export const UNDERWRITER_IMAGES = {
  [UNDERWRITER_TYPE.PGA_SOMPO_INSURANCE_CORPORATION]: {
    icon: PGASompoImage,
    signature: PGASignature,
  },
  [UNDERWRITER_TYPE.UNITED_INSURANCE_COMPANY_OF_VIETNAM]: {
    icon: UICSompoImage,
    signature: FeCreditSignature,
  },
};

export const NPS_EMAIL_MODAL_PARAMS = {
  BOOKING_ID: 'bookingID',
  SCORE: 'score',
  SOURCE: 'source',
  NPS_SOURCE: 'nps_source',
};

export const NPS_SMS_MODAL_PARAMS = {
  BOOKING_ID: 'bookingID',
  SOURCE: 'source',
  NPS_SOURCE: 'nps_source',
};

export const US_SPECIAL_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'DE',
  'DC',
  'FL',
  'HI',
  'ID',
  'IN',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MN',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'TN',
  'TX',
  'VT',
  'VA',
  'WA',
  'WV',
];

export const KW_FE_MESSAGES_SLUG = 'xcovercom-kw-fe-messages';
